<script lang="ts" setup>
import { currencies } from '@/constants';
import useExchangeRates from '@/helpers/currency/useExchangeRates';
import { valueFormat } from '@/helpers/valueFormat';
import { useAppStore } from '@/store/app';
import { computed } from 'vue';

const props = defineProps<{
  totalValue: number;
}>();

const { data: exchangeRates } = useExchangeRates();

const currency = currencies.find((c) => c.name === 'SOL');

const app = useAppStore();

const text = computed(() => {
  if (!exchangeRates.value || !currency || !props.totalValue) {
    return null;
  }
  return valueFormat(props.totalValue, {
    currency: currency,
    currencyRate: exchangeRates.value[currency.name] ?? 0,
  });
});
</script>

<template>
  <p v-show="!app.hideValues && text" class="text-disabled">≈ {{ text }}</p>
</template>
